class SiteHead {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.hamburger = self.elem.querySelector('[data-nav-toggle]');
        self.html = document.getElementsByTagName("HTML")[0];
        self.body = document.body;
        self.nav = self.elem.querySelector('[data-nav]');
        self.dropdowns = self.elem.querySelectorAll('[data-dropdown-item]');
        self.dropdownsTrigger = self.elem.querySelectorAll('[data-dropdown-trigger]');
    }

    init() {
        let self = this;

        self.navToggle();
        self.dropdownToggle();
        self.isScrolled();
    }

    navToggle() {
        let self = this;

        self.hamburger.addEventListener('click', function() {
            self.hamburger.classList.toggle('is-open');
            self.html.classList.toggle('overflow-hidden');
            self.elem.classList.toggle('is-open');
            self.nav.classList.toggle('is-open');
        });
    }

    dropdownToggle() {
        let self = this;

        Array.from(self.dropdowns).map(item => {
            let trigger = item.querySelector('[data-dropdown-trigger]');

            if (trigger !== null) {
                trigger.addEventListener('click', evt => {
                    evt.preventDefault();
                    if (item.classList.contains('is-open')) {
                        item.classList.remove('is-open');
                        trigger.setAttribute('aria-expanded', false);
                    } else {
                        item.classList.add('is-open');
                        trigger.setAttribute('aria-expanded', true);
                    }
                });
            }
        });
    }

    isScrolled() {
        let self = this;

        window.onscroll = function (e) {
            if (scrollY > 0) {
                self.elem.classList.add('is-fixed');
                self.body.style.paddingTop = self.elem.offsetHeight+'px';
            } else {
                self.elem.classList.remove('is-fixed');
                self.body.style.paddingTop = 0;
            }
        }
    }
}

export default SiteHead;
